module.exports = __webpack_public_path__ + "static/media/webicongrey.cacd5325.png";